// "Nothing in this range" note for a Metrics tab. When the filters match
// nothing in the selected range, the cards alone read as a broken page, so
// the tab says so, names the most recent match outside the range, and
// offers a one-click widen to Last 12 months.
//
//   renderEmptyNote(el, { noun: 'jobs', rangeLabel: 'in the last 30 days',
//                         latest: '2026-04-14', onWiden })
//   renderEmptyNote(el, null)   // hide
//
// latest: ISO date of the most recent match ignoring the range, or null
// when nothing matches at all. onWiden is omitted when already at the
// widest range.
function fmtLatest(iso) {
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00` : iso)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export default function renderEmptyNote(el, opts) {
  if (!el) return
  el.replaceChildren()
  if (!opts) {
    el.toggleAttribute('hidden', true)
    return
  }
  const { noun, rangeLabel, latest, onWiden } = opts
  const text = document.createElement('span')
  if (latest) {
    text.textContent = `No ${noun} match these filters ${rangeLabel}. The most recent one is from ${fmtLatest(latest)}.`
  } else {
    text.textContent = `No ${noun} match these filters in any date range.`
  }
  el.appendChild(text)
  if (latest && onWiden) {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'm-empty-note-btn'
    btn.textContent = 'Show last 12 months'
    btn.addEventListener('click', onWiden)
    el.appendChild(btn)
  }
  el.toggleAttribute('hidden', false)
}

// "in the last 30 days" / "since January 1" / "in the last 12 months" for
// a range select's value.
export function rangePhrase(value) {
  if (value === 'ytd') return 'since January 1'
  if (value === '365') return 'in the last 12 months'
  return `in the last ${value} days`
}
